const KEY_CODES = {
	33: 'pageUp',
	34: 'pageDown',
	37: 'left',
	38: 'up',
	39: 'right',
	40: 'down',
	27: 'escape',
	13: 'enter',
	17: 'control'
};

export { KEY_CODES };
